import JsSIP from 'jssip';
import VueDragResize from 'vue-drag-resize'
export default {
    name:'utm-call-up',
    components:{VueDragResize},
    data(){
        return{
            mySipInfo:{},//当前账号的SIP信息
            sipApiRoot:window.g.SIP_ROOT,
            userAgent:null,//通信代理
            currentSession:null,
            sessionStatus:1,//0——来电     1——会话中
            otherSipInfo:{},//来电信息
            dialogModal:false,
            busyLine:false,
            // 会话的时长计算
            startTime:0,
            callDuration:'00:00:00',
            timeLine:null,
            /* 电脑输出输入的使用 */
            inputList:[],//输入设备
            outputList:[],//输出设备
            deviceInfo:{},//当前使用输入输出设备
            videoDom:null,
            silence:false,

            // 远程开门的
            checkedAccessZone:[],//选择开门的点位
            checkedBarrierGateZone:[],//选择开道闸的点位
            accessZoneList:[]
        }
    },
    beforeDestroy(){
        this.unregisterSip();
    },
    mounted(){
        // 获取当前登录人的SIP信息
        this.getCurrentSip();
        //获取电脑的输入输出设备
        this.getDeviceList();
    },
    methods:{
        // 获取当前登录账号的SIP,如果当前账号绑定了SIP，有连接地址，才可以建立通讯连接
        getCurrentSip:function(){
            let _this = this;
            // 重新登录后重新连接需要取消之前的连接
            this.unregisterSip();
            this.$ajax.get('SipAccount/GetSipInfo',{headers:{noLoading:true}}).then(res =>{
                if(res.data.success){
                    let data = res.data.data;
                    if(data && data.webRTCExten){
                        let wsStr = 'wss://';
                        let index = _this.sipApiRoot.indexOf('//');
                        if(index === 5){ /*http类型 */
                            wsStr = 'ws://';
                        }
                        let sipPrefix = _this.sipApiRoot.substr(index + 2);
                        _this.mySipInfo = {
                            sipId:data.webRTCExten,
                            password:data.webRTCPassword,
                            wsUrl: wsStr + sipPrefix + ':8089/ws',
                            sipUrl:'sip:' + data.webRTCExten + '@' + sipPrefix
                        };
                        _this.initSip();
                        //刷新界面之后需要重新进入会议
                        if (localStorage.getItem('isCallUp') === 'true') {
                           _this.startCallUp();
                        }
                    }
                }
            })
        },
        //取消连接通讯
        unregisterSip:function(){
         if(!this.userAgent){
             return false;
         }
         this.userAgent.unregister({
             all: true, // 取消所有注册
             // 其他选项可以在这里添加
         });
        },
        //初始化连接通讯
        initSip:function(){
            // JsSIP用户代理需要一个配置对象来进行初始化。
            let _this = this;
            let socket = new JsSIP.WebSocketInterface(this.mySipInfo.wsUrl);
            let configuration = {
                sockets  : [ socket ],
                uri      : this.mySipInfo.sipUrl,
                password : this.mySipInfo.password,
                sessionTimers: false // 关闭会话定时器 
            };

            this.userAgent = new JsSIP.UA(configuration);
            this.eventsUserAgent();
            // 监听 WebSocket 连接事件
            socket.onconnect = function() {
                console.log('WebSocket connected successfully');
            };
            // 监听 WebSocket 错误事件
            socket.onerror = function(error) {
                console.error('WebSocket connection error:', error);
            };
            // 监听 WebSocket 关闭事件
            socket.ondisconnect = function() {
                console.log('WebSocket disconnected');
            };
            
            this.userAgent.start();
        },

        //监听注册状态
        eventsUserAgent:function(){
            let _this = this;
            this.userAgent.on('registered', function (data) {
                console.info("registered: ", data.response.status_code, ",", data.response.reason_phrase);
            });
            //1.在注册到期之前发射几秒钟。如果应用程序没有为这个事件设置任何监听器，JsSIP将像往常一样重新注册。
            // 2.如果应用程序订阅了这个事件，它负责ua.register()在registrationExpiring事件中调用（否则注册将过期）。
            // 3.此事件使应用程序有机会在重新注册之前执行异步操作。对于那些在REGISTER请求中的自定义SIP头中使用外部获得的“令牌”的环境很有用。
            this.userAgent.on('registrationExpiring', function () {
                _this.userAgent.register()
            });
            // 监听来电事件
            this.userAgent.on('newRTCSession', (data) => {
                //判断是来电还是主动拨打
                if (_this.busyLine) {
                    console.log('忙线')
                    return false;
                }
                _this.busyLine = true;
                let sip = data.request.from._uri._user
                _this.getOtherSipInfo(sip);
                _this.currentSession = data.session;
                _this.sessionStatus = 0;
                _this.eventsCurrentSession();
            });
        },
        //监听当前会话
        eventsCurrentSession:function(){
            let _this = this;
            console.log(this.currentSession);
            //创建基础RTCPeerConnection后激发。应用程序有机会通过在peerconnection上添加RTCDataChannel或设置相应的事件侦听器来更改peerconnection。
            this.currentSession.on('peerconnection', function (data) {
                data.peerconnection.onaddstream = function (ev) {
                    console.info('onaddstream from remote - ', ev);
                    _this.videoDom.srcObject = ev.stream;
                };
            });
            //failed 事件： 当通话失败时触发，可以用于捕获对方断线的情况。
            this.currentSession.on('failed', function(e) {
                console.log('Call failed:', e);
                _this.autoHangUp();
            });
            //ended 事件： 当通话结束时触发，可以用于捕获对方挂断的情况。
            this.currentSession.on('ended', function(e) {
                console.log('Call ended:', e);
                _this.autoHangUp();
            });
            //bye 事件： 当对方发送 BYE 请求时触发，表示对方主动挂断通话
            this.currentSession.on('bye', function(e) {
                console.log('Call ended by remote party:', e);
                _this.autoHangUp();
            });
        },
        //手动接听来电
        //回答传入会话。此方法仅适用于传入会话。
        //answer设置的自动接听
        //RTCSession 的 answer 方法做了自动接听。实际开发中，你需要弹出一个提示框，让用户选择是否接听
        handleAnswer:function(){
            let _this = this;
            this.currentSession.answer({
                'mediaConstraints': {'audio': true, 'video': false},
                'mediaStream': null,
                sessionTimersExpires:36000//默认设置10个小时
            });
            this.sessionStatus = 1;
            this.startTime = this.moment().valueOf();
            this.computeCallDuration();
            _this.initDeviceInfo();
            _this.callPoint(_this.otherSipInfo.sip);
        },
        //手动挂断
        handleHangUp:function(){       
            this.currentSession.terminate();
            //代码的复用
            this.autoHangUp();
        },
        //对方断线,己方自动挂断
        autoHangUp:function(){
            this.busyLine = false;
            let _this = this;
            this.dialogModal = false;
            this.clearCallDuration();
            if (this.videoDom && this.videoDom.srcObject) {
                this.videoDom.srcObject.getTracks().forEach(track => track.stop());
            }
            // 获取本地音频流
            const localStream = this.currentSession.connection.getLocalStreams()[0];
            // 将本地音频流的音量设置为 0
            localStream.getAudioTracks().forEach(track => {
                track.enabled = true; // 启用音频轨道
                _this.silence = false;
            });
        },
        computeCallDuration:function(){
            let _this = this;
            this.timeLine = setInterval(() => {
                let entTime = _this.moment().valueOf();
                _this.callDuration = _this.moment.utc(parseInt(entTime -  _this.startTime)).format("HH:mm:ss")
            }, 1000);
        },
        clearCallDuration:function(){
            this.startTime = 0;
            this.callDuration = '00:00:00';
            clearInterval(this.timeLine);
        },
        // 禁音功能
        toggleSilence:function () { 
            let _this = this;
            // 获取本地音频流
            const localStream = this.currentSession.connection.getLocalStreams()[0];
            // 将本地音频流的音量设置为 0
            localStream.getAudioTracks().forEach(track => {
                if(track.enabled){
                    track.enabled = false; // 禁用音频轨道
                    _this.silence = true;
                }else{
                    track.enabled = true; // 启用音频轨道
                    _this.silence = false;
                }
            });
        },
        /* ***********************************关于 Ultimo的对接逻辑**************************************** */
        getOtherSipInfo:function(sip){
            let _this = this;
            this.$ajax.get('SipDevice/GetDeviceInfo/'+ sip,{headers:{noLoading:true}}).then(res =>{
                if(res.data.success){
                    _this.otherSipInfo = res.data.data;
                    _this.otherSipInfo.sip = sip;
                    _this.dialogModal = true;
                    //如果是对讲机需要获取远程开门的信息
                    if(_this.otherSipInfo.type === 2){
                        _this.getAccessZones();
                    }
                }
            })
        },
        shrinkCallBox:function(e){
            $(e.target).parents('.call-content').find('.call-box-arrow').toggleClass('open');
            $(e.target).parents('.call-content').find('.session-box-swapper').slideToggle();
        },

        // Call Point
        callPoint:function(sip){
            let _this = this;
            let params = {
                sipAccount: sip
            } 
            this.$ajax.post('IncidentTrigger/CallPoint',params,{headers:{noLoading:true}}).then(res =>{
                if(!res.data.success){
                    _this.messageNotice('error','Please select door');
                }
            })
        },
        /* ****************************关于电脑的输入输出设备的逻辑************************************************* */
        //初始化输入输出设备
        initDeviceInfo(){
            // 默认使用设备列表的第一个设备
            let _this = this;
            _this.$nextTick(()=>{
                _this.videoDom = document.getElementById('remoteVideo');
                if(_this.inputList.length > 0){
                    _this.deviceInfo.inputId = _this.inputList[0].deviceId;
                }
                if(_this.outputList.length > 0){
                    _this.deviceInfo.outputId = _this.outputList[0].deviceId;
                    _this.videoDom.setSinkId(_this.deviceInfo.outputId);
                }
            });
        },
        // 获取当前电脑的输入输出设备
        getDeviceList(){
            let _this = this;
            _this.outputList = [];
            _this.inputList = [];
            if(navigator.mediaDevices){
                navigator.mediaDevices.enumerateDevices().then(arr =>{
                    arr.forEach(el => {
                        if(el.kind === 'audiooutput'){
                            _this.outputList.push(el);
                        }
                        else if(el.kind === 'audioinput'){
                            _this.inputList.push(el);
                        }
                    });
                });
            }
            
            console.log(_this.outputList);
        },
        //打开设备切换面板
        shrinkDeviceBox:function(e){
            $(e.target).parents('.action-bar').find('.system-device-box .system-device-arrow').toggleClass('open');
            $(e.target).parents('.action-bar').find('.system-device-box .system-device-panel').slideToggle();
        },
        // 切换输入设备 —— 跟换麦克风
        changeInputDevice:function(deviceId){
            let _this = this;
            this.deviceInfo.inputId = deviceId;
            navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: deviceId } } }).then(stream => {
                // 获取本地音频轨道
                const audioTrack = stream.getAudioTracks()[0];
                // 获取当前会话的连接
                const connection = _this.currentSession.connection;
                // 替换本地音频轨道
                connection.getLocalStreams()[0].removeTrack(connection.getLocalStreams()[0].getAudioTracks()[0]);
                connection.getLocalStreams()[0].addTrack(audioTrack);

                // 重新发送音频流
                _this.currentSession.renegotiate();
            }).catch(error => {
                console.error('Error changing microphone:', error);
            });
        },
        // 切换输出设备 —— 更换扬声器
        changeOutputDevice:function(deviceId){
            this.deviceInfo.outputId = deviceId;
            this.videoDom.setSinkId(deviceId).then(() => {
                console.log('Speaker set to', deviceId);
            }).catch(error => {
                console.error('Error changing speaker:', error);
            });
        },
        /* *************************远程开门的相关逻辑******************* */
        expandList(e){
            this.togglePanel(1);
        },
        togglePanel(type){
            if(type){
                $('#call_up .remote-door-arrow').addClass('open');
                $('#call_up .remote-panel').slideDown(250);
            }else{
                $('#call_up .remote-door-arrow').removeClass('open');
                $('#call_up .remote-panel').slideUp(250);
            }
        },
        getAccessZones(){
            let _this = this;
            this.checkedAccessZone = [];
            this.checkedBarrierGateZone = [];
            this.$ajax.get('AccessZone/GetBySipDeviceId/' + _this.otherSipInfo.id,{headers:{noLoading:true}}).then(res =>{
                if(res.data.success){
                    _this.accessZoneList = res.data.data;
                }else{
                    _this.accessZoneList = [];
                }
            })
        },
        checkDoor(door) {
            let index
            if(door.type === 1) {
                index = this.checkedAccessZone.findIndex(id => door.id === id);
                if (index > -1) {
                    this.checkedAccessZone.splice(index, 1);
                } else {
                    this.checkedAccessZone.push(door.id)
                }
            }
            if(door.type === 2) {
                index = this.checkedBarrierGateZone.findIndex(id => door.id === id);
                if (index > -1) {
                    this.checkedBarrierGateZone.splice(index, 1);
                } else {
                    this.checkedBarrierGateZone.push(door.id)
                }
            }
        },
        //确认开门
        openDoor:function(){
            let _this = this;
            if(_this.checkedAccessZone.length === 0 && _this.checkedBarrierGateZone.length === 0){
                _this.messageNotice('error','Please select door or barrier gate');
                return;
            }
            if(_this.checkedAccessZone.length) {
                let openDoorParams = { accessZoneIds: _this.checkedAccessZone, controlType: 0};
                this.$ajax.post('DoorAccessControl/RemoteControlDoor', openDoorParams).then(res => {
                    if (res.data.success) {
                        _this.togglePanel(0);
                        _this.messageNotice('success');
                    }
                })
              }
              if(_this.checkedBarrierGateZone.length) {
                let openBarrierGateParams = { accessZoneIds: _this.checkedBarrierGateZone, controlType: 0};
                this.$ajax.post('DoorAccessControl/BatchRemoteControlBarrierGate', openBarrierGateParams).then(res => {
                    if (res.data.success) {
                        _this.togglePanel(0);
                        _this.messageNotice('success');
                    }
                })
              }
        }
    },
}


// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/utm-call-up/utm-call-up.js